"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _decorators = require("decorators");

var _pageLink = babelHelpers.interopRequireDefault(require("./pageLink"));

var Channel = _exports.default.Channel;

var CustomLinkCard =
/*#__PURE__*/
function (_PageLinkCard) {
  babelHelpers.inherits(CustomLinkCard, _PageLinkCard);

  function CustomLinkCard() {
    babelHelpers.classCallCheck(this, CustomLinkCard);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CustomLinkCard).apply(this, arguments));
  }

  return CustomLinkCard;
}(_pageLink.default);

exports.default = CustomLinkCard;